

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "./Assesment.css";
import StarfieldCanvas from "./StartFeildCanvas";
import jsPDF from "jspdf";
import Certificate from "../../../../../assets/Certificate.jpg"


export default function CertificationHub({  currentScreenId,setCurrentScreenId ,gameInfo,learnerPlayList,setLearnerPlayingDetails}:any) {

const [isEligibleForDownload, setIsEligibleForDownload] = useState(false);
  const [hasAssessment, setHasAssessment] = useState(false);
useEffect(() => {
 

  if (!learnerPlayList || !learnerPlayList.Assessment) return;

    const assessmentData = learnerPlayList.Assessment || [];

    // Check whether assessment exists
    setHasAssessment(assessmentData.length > 0);


    // If no assessment data, don't calculate scores
    if (assessmentData.length === 0) {
      setIsEligibleForDownload(false);
      return;
    }

  const originalScore = Math.max(
    ...assessmentData.map((item: any) => item?.originalScore || 0)
  );

  const finalScore = Math.max(
    ...assessmentData.map((item: any) => item?.finalScore || 0)
  );



  setIsEligibleForDownload(
    originalScore >= 80 || finalScore >= 80
  );
}, [learnerPlayList]);
  return (
    <div className="assess-page">
      <StarfieldCanvas />
      <div className="assess-scanlines" />
      <div className="assess-wrap">
        <div className="assess-card" style={{ maxWidth: 520, padding: "40px 32px", alignItems: "center", textAlign: "center" }}>
          <div style={{ position: "relative", zIndex: 1 }}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>🎓</div>
            <h1 style={{ fontSize: 22, fontWeight: 800, color: "#fff", margin: "0 0 6px" }}>
              Certification Hub
            </h1>
            <p style={{ fontSize: 13, color: "rgba(255,255,255,0.7)", margin: "0 0 28px", lineHeight: 1.45 }}>
              Manage your certification, download your reports, or reattempt the assessment.
            </p>

            <div style={{ display: "flex", flexDirection: "column", gap: 12, width: "100%" }}>
              <button
                className="assess-primary-btn"
                onClick={() =>setCurrentScreenId(17)}
                style={{ padding: "14px 24px", fontSize: 14, width: "100%" }}
              >
                {hasAssessment ? "🔄 Reattempt Assessment" : "▶️ Start Assessment"}
              </button>
            {isEligibleForDownload && (
  <>
    <button
      className="assess-primary-btn"
      onClick={() => setCurrentScreenId(22)}
    >
      📜 Download Certificate
    </button>

    <button
      className="assess-primary-btn"
      onClick={() => setCurrentScreenId(19)}
    >
      📊 Download Report
    </button>
  </>
)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
